import { init } from "./init";
init();
export * from "./lang";
export var VERSION = "0.3.21";
